import React from "react";
import Header from "../../Header";
import "../../styles/theme.scss";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import ClaimTab from "../../components/Claim/ClaimTab";
const Content = styled("div")(({ theme }) => ({
  flexGrow: 1,
  paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // Add margin top here
  // marginTop: theme.spacing(10), // Adjust the spacing as needed
}));
function ClaimContent() {
  const navigate = (path) => {
    // Your custom navigation logic here
    console.log("Navigating to:", path);
    // For example, you might use window.location.href to change the URL
    window.location.href = path;
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Grid>
      <Header
        navigate={handleNavigation}
        children={
          <Content>
            <ClaimTab />
          </Content>
        }
      />
    </Grid>
  );
}

export default ClaimContent;
